import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.80005 3.9998C4.80005 3.33706 5.33731 2.7998 6.00005 2.7998H20C20.6628 2.7998 21.2001 3.33706 21.2001 3.9998V17.9998C21.2001 18.6625 20.6628 19.1998 20 19.1998C19.3373 19.1998 18.8 18.6625 18.8 17.9998V6.90887L4.84821 20.8487C4.37938 21.3171 3.61958 21.3168 3.15116 20.848C2.68273 20.3791 2.68306 19.6193 3.15189 19.1509L17.115 5.1998H6.00005C5.33731 5.1998 4.80005 4.66255 4.80005 3.9998Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconArrowUpRightFill = forwardRef(Icon);
export default IconArrowUpRightFill;
